export default __webpack_public_path__ + "a86f1fd5280cc6e2a9d0dbb3a35d3305.png";